import { WhatsappLogo, MapPin, Phone, Clock } from "@phosphor-icons/react";
import { BRAND, buildWhatsAppLink } from "../lib/brand";

const KEYWORDS = [
  "Compro alumínio em Maringá",
  "Compro cobre em Maringá",
  "Sucata de cobre Maringá",
  "Comprador de latinhas Maringá",
  "Compra de cobre encapado",
  "Compra de perfil de alumínio",
  "Reciclagem de metais Maringá-PR",
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-white/10 bg-[var(--rc-bg)]"
    >
      {/* Keyword marquee for SEO + local feel */}
      <div className="overflow-hidden border-b border-white/10 bg-[var(--rc-surface)]">
        <div className="rc-marquee-track flex whitespace-nowrap py-4">
          {[...KEYWORDS, ...KEYWORDS].map((k, i) => (
            <span
              key={i}
              className="px-8 font-mono-ui text-xs text-zinc-500 tracking-widest uppercase flex items-center gap-3"
            >
              <span className="w-1 h-1 bg-[var(--rc-copper-bright)]" />
              {k}
            </span>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-14 sm:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-[1.4fr_1fr_1fr] gap-10">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 grid place-items-center bg-[var(--rc-copper)] text-black font-display font-bold text-lg">
                R
              </span>
              <span className="font-display font-bold tracking-tight text-white text-xl">
                Ricatto<span className="text-[var(--rc-copper-bright)]">.</span>Metais
              </span>
            </div>
            <p className="text-zinc-400 mt-5 max-w-md leading-relaxed">
              Compra de alumínio e cobre em Maringá-PR. Pagamento na hora,
              pesagem justa e retirada rápida em toda a região.
            </p>
            <a
              href={buildWhatsAppLink()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-btn"
              className="rc-btn-whatsapp inline-flex items-center gap-2 px-5 py-3 rounded-md mt-6"
            >
              <WhatsappLogo size={18} weight="fill" />
              <span className="font-display font-bold">Avaliação pelo WhatsApp</span>
            </a>
          </div>

          <div>
            <div className="label-eyebrow mb-4">[ Contato ]</div>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3 text-zinc-300">
                <MapPin size={16} weight="bold" className="text-[var(--rc-copper-bright)] mt-1 shrink-0" />
                <span>{BRAND.addressLine}<br />CEP {BRAND.addressCep}</span>
              </li>
              <li className="flex items-center gap-3 text-zinc-300">
                <Phone size={16} weight="bold" className="text-[var(--rc-copper-bright)]" />
                <span>{BRAND.phoneDisplay}</span>
              </li>
              <li className="flex items-center gap-3 text-zinc-300">
                <Clock size={16} weight="bold" className="text-[var(--rc-copper-bright)]" />
                <span>{BRAND.hours}</span>
              </li>
            </ul>
          </div>

          <div>
            <div className="label-eyebrow mb-4">[ Navegação ]</div>
            <ul className="space-y-2.5 text-sm">
              {[
                ["#materiais", "Materiais que compramos"],
                ["#confianca", "Por que nos escolher"],
                ["#avaliacao", "Pedir avaliação"],
                ["#galeria", "Galeria"],
                ["#localizacao", "Localização"],
                ["#faq", "Dúvidas frequentes"],
              ].map(([href, label]) => (
                <li key={href}>
                  <a
                    href={href}
                    data-testid={`footer-nav-${href.replace("#", "")}`}
                    className="text-zinc-300 hover:text-[var(--rc-copper-bright)] transition-colors"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 text-xs text-zinc-500 font-mono-ui">
          <span>
            © {new Date().getFullYear()} {BRAND.name} · Compra de metais não-ferrosos em {BRAND.region}.
          </span>
          <span>Feito com foco em quem vende metal de verdade.</span>
        </div>
      </div>
    </footer>
  );
}
